import type { EndpointTest } from '@/types/endpointTests';

/** Badge colors per source (task 1175): how the test was created, nothing more. */
const SOURCE_BADGE_CLASS: Record<EndpointTest['source'], string> = {
  generated: 'bg-teal-100 text-teal-800 dark:bg-teal-900 dark:text-teal-200',
  manual: 'bg-gray-100 text-gray-700 dark:bg-gray-700 dark:text-gray-300',
  imported: 'bg-sky-100 text-sky-800 dark:bg-sky-900 dark:text-sky-200',
  'red-team': 'bg-rose-100 text-rose-800 dark:bg-rose-900 dark:text-rose-200',
};

/**
 * Source badge: generated · manual · imported · red-team. Shared by the Tests
 * list and the suite membership dialog (moved out of TestsPanel in task 1209).
 */
export function SourceBadge({ source }: { source: EndpointTest['source'] }) {
  const cls = SOURCE_BADGE_CLASS[source] ?? SOURCE_BADGE_CLASS.manual;
  return (
    <span className={`px-1.5 py-0.5 text-xs rounded-full font-medium ${cls}`}>
      {source}
    </span>
  );
}

export default SourceBadge;
